module.exports = __webpack_public_path__ + "static/media/delay_icon.181675c3.svg";